import { MOKA_GOAUTH_SERVICE } from '../constants';

export const INVENTORY_SUMMARY_SHADOW_PROXY_SERVICE = `${MOKA_GOAUTH_SERVICE}/inventory-summary-shadow-proxy`;

export const GET_ITEM_SUMMARY = `${INVENTORY_SUMMARY_SHADOW_PROXY_SERVICE}/v1/summary-item`;
export const GET_INGREDIENT_SUMMARY = `${INVENTORY_SUMMARY_SHADOW_PROXY_SERVICE}/v1/summary-ingredient`;
